module.exports = __webpack_public_path__ + "static/media/x.99f11663.svg";